import React, { useState, useEffect } from 'react';
import api from '../../api/axios.js';
import { Box, Table, Text, Flex, Avatar } from '@radix-ui/themes';
import './Profile.css';

const Profile = () => {
  const [userDetails, setUserDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchUserDetails = async () => {
      try {
        // Get user ID from localStorage or context
        const user = JSON.parse(localStorage.getItem('user'));
        if (!user) {
          setError('User not found');
          setLoading(false);
          return;
        }

        const response = await api.get(`/users/${user.id}`, {
          params: {
            include: ['Team', 'Branch']
          }
        });
        setUserDetails(response.data);
      } catch (err) {
        setError('Failed to load user details');
        console.error('Error fetching user details:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchUserDetails();
  }, []);

  if (loading) {
    return <div className="profile-loading">Loading...</div>;
  }

  if (error) {
    return <div className="profile-error">{error}</div>;
  }

  if (!userDetails) {
    return <div className="profile-error">No user details found</div>;
  }

  return (
    <div className="profile-container">
      {userDetails && (
        <Box style={{ padding: '2rem', marginBottom: '1rem', background: 'var(--gray-a2)', borderRadius: '8px' }}>
          <Flex align="center" gap="4">
            <Avatar
              size="6"
              src={`https://api.dicebear.com/7.x/initials/svg?seed=${userDetails.firstname?.[0] || ''} ${userDetails.lastname?.[0] || ''}`}
            />
            <Box>
              <Text size="6" weight="bold">{`${userDetails.firstname || ''} ${userDetails.lastname || ''}`}</Text>
              <Flex gap="4" mt="2">
                <Text size="2" color="gray">{userDetails.position || '-'}</Text>
                <Text size="2" color="gray">•</Text>
                <Text size="2" color="gray">{userDetails.Branch?.name || '-'}</Text>
                <Text size="2" color="gray">•</Text>
                <Text size="2" color="gray">{userDetails.Team?.name || '-'}</Text>
              </Flex>
            </Box>
          </Flex>
        </Box>
      )}
    </div>
  );
};

export default Profile;